<template>
  <div class="addCurrencies">
    <div class="top-table-btn">
      <el-button type="primary" @click="insertEvent()"
        ><svg-icon
          class="icon-img"
          style="font-size: 16px; padding-right: 6px"
          icon-class="icon-add"
        />{{ $t('currenciesAndCalendar.addCurrencies.add') }}</el-button
      >
      <el-button type="primary" @click="handleDelete('xTable')"
        ><svg-icon
          class="icon-img"
          style="font-size: 16px; padding-right: 6px"
          icon-class="icon-white-delete"
        />{{ $t('currenciesAndCalendar.addCurrencies.deletChange') }}</el-button
      >
    </div>
    <vxe-table
      border
      :auto-resize="true"
      show-overflow
      size="mini"
      ref="xTable"
      :data="personCompanyDos"
      :edit-rules="validRules"
      :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
    >
      <vxe-table-column type="checkbox" width="80"></vxe-table-column>
      <vxe-table-column
        type="index"
        :title="$t('currenciesAndCalendar.queryCurrencies.index')"
        width="80"
      ></vxe-table-column>
      <vxe-table-column
        field="currencyCode"
        :title="$t('currenciesAndCalendar.queryCurrencies.currencyCode')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-input
            v-model="scope.row.currencyCode"
            @input="$refs.xTable.updateStatus(scope)"
            clearable
          ></el-input>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="currencyName"
        :title="$t('currenciesAndCalendar.queryCurrencies.currencyName')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-input
            v-model="scope.row.currencyName"
            @input="$refs.xTable.updateStatus(scope)"
            clearable
          ></el-input>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="currencyDesc"
        :title="$t('currenciesAndCalendar.queryCurrencies.currencyDesc')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-input
            v-model="scope.row.currencyDesc"
            @input="$refs.xTable.updateStatus(scope)"
            clearable
          ></el-input>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="publicRegion"
        :title="$t('currenciesAndCalendar.addCurrencies.publicRegion')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-input
            v-model="scope.row.publicRegion"
            @input="$refs.xTable.updateStatus(scope)"
            clearable
          ></el-input>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="currencySymbol"
        :title="$t('currenciesAndCalendar.queryCurrencies.currencySymbol')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-input
            v-model="scope.row.currencySymbol"
            @input="$refs.xTable.updateStatus(scope)"
            clearable
          ></el-input>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div class="fixed-bottom-btnList">
      <el-button
        type="primary"
        class="fixed-bottom-btn color"
        icon="el-icon-edit"
        @click="goBack"
        >{{ $t('currenciesAndCalendar.addCurrencies.goBack') }}</el-button
      >
      <el-button
        type="primary"
        class="fixed-bottom-btn color"
        icon="el-icon-edit"
        @click="saveCurrencies"
        >{{ $t('currenciesAndCalendar.addCurrencies.sure') }}</el-button
      >
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/financeCenter/generalAccounting';
  export default {
    name: 'addCurrencies',
    data() {
      var checkcurrencyCode = (rule, value, callback) => {
        let reg = /^[A-Z]+$/;
        let regs = /^[A-Z]{0,10}$/;
        if (!reg.test(value)) {
          callback(new Error(this.$t('currenciesAndCalendar.rules.writeCapital')));
        }
        if (!regs.test(value)) {
          callback(new Error(this.$t('currenciesAndCalendar.rules.writeLength')));
        } else {
          callback();
        }
      };
      var checkCurrencyName = (rule, value, callback) => {
        let reg = /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/;
        let regs = /^[\u4e00-\u9fa5_a-zA-Z0-9]{0,20}$/;
        if (!reg.test(value)) {
          callback(new Error(this.$t('currenciesAndCalendar.rules.formatError')));
        }
        if (!regs.test(value)) {
          callback(new Error(this.$t('currenciesAndCalendar.rules.writeLength')));
        } else {
          callback();
        }
      };
      var checkcurrencyDesc = (rule, value, callback) => {
        let reg = /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/;
        if (!reg.test(value)) {
          callback(new Error(this.$t('currenciesAndCalendar.rules.formatError')));
        } else {
          callback();
        }
      };
      return {
        validRules: {
          currencyCode: [
            {
              required: true,
              message: this.$t('currenciesAndCalendar.addCurrencies.currencyCode'),
            },
            { validator: checkcurrencyCode },
          ],
          currencyName: [
            {
              required: true,
              message: this.$t('currenciesAndCalendar.addCurrencies.currencyName'),
            },
            { validator: checkCurrencyName },
          ],
          currencyDesc: [
            { min: 0, max: 120, message: this.$t('currenciesAndCalendar.rules.writeLength') },
            { validator: checkcurrencyDesc },
          ],
          publicRegion: [{ validator: checkCurrencyName }],
          currencySymbol: [
            { min: 0, max: 20, message: this.$t('currenciesAndCalendar.rules.writeLength') },
          ],
        },
        flag: true,
        dialogVisible: false,
        personCompanyDos: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      user() {
        return this.userInfo.userInfo;
      },
    },
    methods: {
      //增加
      insertEvent() {
        let xTable = this.$refs.xTable;
        let record = {};
        xTable.insertAt(record, 0).then(({ row }) => {
          xTable.setActiveRow(row);
        });
        this.personCompanyDos = this.$refs.xTable.getTableData().fullData;
      },
      // 删除
      handleDelete(tableTpye) {
        const selectedList = this.$refs[tableTpye].getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('personnel.table.chockedLows'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs[tableTpye].removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('personnel.table.deletSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('personnel.table.deletFalse'),
            });
          });
      },
      //取消
      editCurrencies() {
        this.personCompanyDos = [];
      },
      //保存
      saveCurrencies() {
        this.flag = true;
        let formList = ['xTable'];
        let resultArr = [];
        let _self = this;
        function validates(formName) {
          let result = new Promise((resolve, reject) => {
            _self.$refs[formName].validate((valid) => {
              valid ? resolve() : reject();
            });
          });
          resultArr.push(result);
        }
        formList.forEach((item) => {
          validates(item); // 循环校验
        });
        this.personCompanyDos = this.$refs.xTable.getTableData().fullData;
        if (this.personCompanyDos.length <= 0) {
          this.flag = false;
        }
        return Promise.all(resultArr)
          .then(() => {
            if (!this.flag) {
              this.$message({
                showClose: true,
                message: this.$t('personnel.table.tableTitle'),
                type: 'error',
              });
            } else {
              this.save(this.personCompanyDos);
            }
          })
          .catch(() => {});
      },
      save(val) {
        this.$axios.post(API.ADD_CURRENCYS, val).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            this.goBack();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //取消
      goBack() {
        let pathList = {
          fromPath: {
            path: '/generalAccounting/addCurrencies',
            name: 'addCurrencies',
            meta: {
              keepAlive: true,
              title: this.$t('currenciesAndCalendar.addCurrencies.addCurrencies'),
            },
          },
          toPath: {
            path: '/generalAccounting/queryCurrencies',
            name: 'queryCurrencies',
            meta: {
              keepAlive: false,
              title: this.$t('currenciesAndCalendar.addCurrencies.queryCurrencies'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .addCurrencies .creatButton {
    background-color: rgb(98, 153, 254) !important;
    border: 1px solid rgb(98, 153, 254) !important;
    min-width: 80px;
    border-radius: 2px !important;
    margin-bottom: 10px;
  }
  .addCurrencies .deteButton {
    background-color: #fe8783 !important;
    border: 1px solid #fe8783 !important;
    min-width: 80px;
    border-radius: 2px !important;
    margin-bottom: 10px;
  }
</style>
